import React, { ReactElement } from 'react'
import * as styles from './customButton.styles'
import { useNavigate } from 'react-router-dom'
import { FaArrowRight } from 'react-icons/fa'
import { Spinner } from 'flowbite-react'
interface CustomButtonProps {
    text:string | ReactElement,
    route?:string
    icon?:any,
    onClick?:Function,
    className?:string,
    loading?: boolean;
    disabled?:boolean
}
const CustomButton = ({text,route,icon,onClick,disabled, className,loading}:CustomButtonProps) => {
    const navigate = useNavigate()
    const getAction =():any =>{
        if(onClick) return onClick
        if(route) return ()=> navigate(route)
        return ()=>console.log("No action specified")
    }
    const combinedButtonWrapperClass = `relative ${styles.buttonWrapper} ${className} bg-custom-button-green hover:bg-green-800 hover:text-white ${disabled ? 'cursor-not-allowed opacity-50' : ''}`;

    return (
        <button onClick={getAction()} disabled={disabled} className={combinedButtonWrapperClass}>
            <div className={styles.buttonMain}>
                <p className={styles.buttonText}>{text}</p>
                {/* <FaArrowRight /> */}
                {!loading && icon}
            </div>
            {loading && (
                <div className={styles.spinner}>
                    <Spinner size="sm" />
                </div>
            )}
        </button>
    )
}

export default CustomButton